module.exports = __webpack_public_path__ + "static/img/staffPosition.3cee0b26.svg";